var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ImageRepository {
    constructor(fetchCacheImage) {
        this.memCache = new Map();
        this.fetchCacheImage = fetchCacheImage;
    }
    getCacheImage(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.memCache.has(accountId)) {
                return this.memCache.get(accountId);
            }
            else {
                try {
                    const image = yield this.fetchCacheImage(accountId);
                    this.memCache.set(accountId, image || '');
                    return image;
                }
                catch (error) {
                    console.error('Error fetching image:', error);
                    return null;
                }
            }
        });
    }
}
export default ImageRepository;
